import { useInfiniteQuery } from "@tanstack/react-query";

import { getStorefrontHome } from "../services/frontend/storefront-apis";

const fetchStorefrontHome = async ({ queryKey, pageParam = 1 }) => {
  const [, limit, productLimit] = queryKey;

  const data = await getStorefrontHome({
    page: pageParam,
    limit,
    productLimit,
  });

  return {
    collections: data.collections || [],
    reviews: data.reviews,
    page: data.page ?? pageParam,
    limit: data.limit ?? limit,
    nextPage: pageParam + 1,
    hasNextPage: Boolean(data.hasNextPage),
  };
};

const useStorefrontHome = (limit = 5, productLimit = 4) => {
  return useInfiniteQuery({
    queryKey: ["storefrontHome", limit, productLimit],
    queryFn: fetchStorefrontHome,
    getNextPageParam: (lastPage) => (lastPage.hasNextPage ? lastPage.nextPage : undefined),
    cacheTime: 30 * 1000,
    staleTime: 30 * 1000,
  });
};

export default useStorefrontHome;
